import { gql } from '@apollo/client';

export const CURRENT_USER = gql`
  query currentUser {
    current_user {
      id
      firstName
      lastName
      firebaseUID
      email
      departmentId
      initialTourFollowed
      profilePicture
      user_user_roles_user_roles {
        userRoleId
        user_role {
          name
        }
      }
      current_user_routes_route {
        current_user_route {
          id
          name
          componentName
          path
          iconName
          dummy
          showInMenu
          order
          current_user_route_parent {
            id
            name
          }
        }
      }
      course_coordinators {
        batchId
        semesterId
      }
    }
  }
`;

export const UPDATE_INITIAL_TOUR_FOLLOWED = gql`
  mutation updateInitialTourFollowed($_set: current_user_set_input, $where: current_user_bool_exp!) {
    update_current_user(_set: $_set, where: $where) {
      affected_rows
    }
  }
`;

export const USER = gql`
  query user($where: user_bool_exp) {
    user(where: $where) {
      id
      employeeID
      firstName
      middleName
      lastName
      preferredName
      passportNo
      dateOfJoining
      email
      nicNo
      mobileNo
      landLineNo
      extensionNo
      married
      dateOfBirth
      gender
      profilePicture
      homeStreetAddress1
      homeStreetAddress2
      homeCity
      homeCountry
      homeProvince
      homeDistrict
      permanentStreetAddress1
      permanentStreetAddress2
      permanentCity
      permanentCountry
      permanentProvince
      permanentDistrict
      insuranceName
      policyNo
      expirationDate
      healthConditions
      allergies
      currentMedications
      emergencyContact1Name
      emergencyContact1Relationship
      emergencyContact1LandLineNo
      emergencyContact1WorkPhoneNo
      emergencyContact1MobileNo
      emergencyContact1StreetAddress1
      emergencyContact1StreetAddress2
      emergencyContact1City
      emergencyContact1Country
      emergencyContact1Province
      emergencyContact1District
      emergencyContact2Name
      emergencyContact2Relationship
      emergencyContact2LandLineNo
      emergencyContact2WorkPhoneNo
      emergencyContact2MobileNo
      emergencyContact2StreetAddress1
      emergencyContact2StreetAddress2
      emergencyContact2City
      emergencyContact2Country
      emergencyContact2Province
      emergencyContact2District
      user_user_roles_user_roles {
        user_role {
          id
        }
      }
      department {
        id
        name
      }
    }
  }
`;

export const CREATE_USER = gql`
  mutation createUser($data: CreateUserInput!) {
    createUser(data: $data) {
      employeeID
    }
  }
`;

export const PROFILE_PICTURE_UPLOAD_URL = gql`
  query profilePictureUploadURL($data: ProfilePictureUploadURLInput!) {
    profilePictureUploadURL(data: $data) {
      url
    }
  }
`;

export const RECRUITMENT_OFFICERS = gql`
  query recruitmentOfficers($where: user_public_bool_exp) {
    user_public(where: $where) {
      id
      firstName
      lastName
    }
  }
`;

export const USER_LIST = gql`
  subscription userList($where: user_bool_exp, $order_by: [user_order_by!]) {
    user(where: $where, order_by: $order_by) {
      id
      firstName
      lastName
      email
      mobileNo
      employeeID
      active
      department {
        id
        name
      }
    }
  }
`;

export const USERS_DEACTIVATE = gql`
  mutation updateUserActiveState($data: UpdateUserActiveStateInput!) {
    updateUserActiveState(data: $data) {
      employeeID
    }
  }
`;

export const UPDATE_USER = gql`
  mutation updateUser($where: UpdateUserWhereInput!, $data: UpdateUserInput!) {
    updateUser(where: $where, data: $data) {
      employeeID
    }
  }
`;

export const LECTURER_LIST = gql`
  subscription lecturerList($where: lecturer_bool_exp, $order_by: [lecturer_order_by!]) {
    lecturer(where: $where, order_by: $order_by) {
      id
      lastName
      firstName
      employeeID
      subject_to_users {
        id
        priority
        subject {
          id
          code
          name
          hoursPerSlot
          minutesPerSlot
          totalSlots
        }
      }
    }
  }
`;

export const LECTURER_LIST_FOR_SELECT = gql`
  query lecturerListForSelect($where: lecturer_bool_exp, $order_by: [lecturer_order_by!]) {
    lecturer(where: $where, order_by: $order_by) {
      id
      lastName
      firstName
      employeeID
    }
  }
`;

export const LECTURER = gql`
  query lecturer($where: lecturer_bool_exp, $order_by: [lecturer_order_by!]) {
    lecturer(where: $where, order_by: $order_by) {
      id
      lastName
      firstName
      employeeID
      subject_to_users {
        id
        priority
        subjectId
      }
    }
  }
`;

export const LECTURER_FOR_RESULT_SHEET = gql`
  query lecturerForResultSheet($where: lecturer_bool_exp) {
    lecturer(where: $where) {
      id
      firstName
      lastName
    }
  }
`;

export const RE_SEND_LOGIN_EMAIL = gql`
  mutation reSendLoginEmail($data: ReSendLoginEmailInput!) {
    reSendLoginEmail(data: $data) {
      studentEmail
      userEmail
    }
  }
`;
